module.exports = require('./helpers/bundle-url').getBundleURL('hX3nb') + "logo-dark.eefe0b7f.svg";